import { render, staticRenderFns } from "./sortDropdown.vue?vue&type=template&id=53780a30&"
import script from "./sortDropdown.vue?vue&type=script&lang=js&"
export * from "./sortDropdown.vue?vue&type=script&lang=js&"
import style0 from "./sortDropdown.vue?vue&type=style&index=0&id=53780a30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports